import styled from "styled-components";

export const PageBackground = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  background-color: ${(props) => props.theme.tokens.colors.bg};
`;

export const PageShell = styled.div`
  width: 100%;
  max-width: 480px;
  min-height: 100vh;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

export const LoadingCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  font-family: ${(p) => p.theme.tokens.font.family};
  font-weight: 800;
  font-size: 15px;
  color: ${(p) => p.theme.tokens.colors.muted};
`;
